import { DeployedInstanceTags, instanceMetaData, InstanceParametersType } from "../../redux/api/api.types";

export function getSalesContactData(metadata: instanceMetaData): string {
    // Verify that there is actual data to parse over
    if (metadata?.sales_contacts?.length === 0) {
        return "No data";
    };

    const contacts: string[] = [];
    metadata?.sales_contacts?.forEach(element => {
        // eslint-disable-next-line camelcase
        contacts.push(`${element.sales_firstname} ${element.sales_lastname} <${element.sales_email}>`);
    });

    return contacts.join('; ');
};

export function getContactData(parameters: InstanceParametersType): string {
    const djangoParams = parameters.django;
    const email: string = Object.prototype.hasOwnProperty.call(djangoParams, 'cuemail') ? `<${djangoParams.cuemail}>` : "";
    const firstName: string = Object.prototype.hasOwnProperty.call(djangoParams, 'culastname') ? `${djangoParams.cufirstname} ` : "";
    const lastName: string = Object.prototype.hasOwnProperty.call(djangoParams, 'cufirstname') ? `${djangoParams.culastname} ` : "";

    return `${firstName}${lastName}${email}`;
};

export function getDeployedApplicationsData(tagData: DeployedInstanceTags): string {
    // eslint-disable-next-line camelcase
    const feVersion: string = Object.hasOwn(
        tagData.applications, "radeaio-core-ui"
    ) ? tagData.applications["radeaio-core-ui"].tag_name : "-";
    // eslint-disable-next-line camelcase
    const beVersion: string = Object.hasOwn(
        tagData.applications, "radeaio-core-backend"
    ) ? tagData.applications["radeaio-core-backend"].tag_name : "-";

    return `${feVersion} / ${beVersion}`;
};
